import { useTranslation } from "react-i18next";
import {
  formatPercentValue,
  formatSignedPercentValue,
  getLocaleForLanguage,
} from "./confrontationMetrics";
import { formatConfrontationParentCategoryLabel } from "./confrontationMappers";

const clampPercent = (value) => {
  if (value == null) return 0;
  return Math.min(100, Math.max(0, value));
};

const ConfrontationComparisonChart = ({ rows = [] }) => {
  const { t, i18n } = useTranslation();
  const locale = getLocaleForLanguage(i18n.language);

  if (!rows.length) {
    return (
      <p className="confrontation-comparison__empty">
        {t("No confrontation available")}
      </p>
    );
  }

  return (
    <div className="confrontation-comparison">
      <div className="confrontation-comparison__header">
        <div className="confrontation-comparison__header-cell">
          {t("Parent category")}
        </div>
        <div className="confrontation-comparison__header-cell confrontation-comparison__header-cell--bars">
          <span className="confrontation-comparison__legend-item">
            <span
              className="confrontation-comparison__swatch confrontation-comparison__swatch--manual"
              aria-hidden
            />
            {t("confrontation.manual")}
          </span>
          <span className="confrontation-comparison__legend-item">
            <span
              className="confrontation-comparison__swatch confrontation-comparison__swatch--ai"
              aria-hidden
            />
            {t("confrontation.ai")}
          </span>
        </div>
        <div className="confrontation-comparison__header-cell confrontation-comparison__header-cell--gap">
          {t("confrontation.signedGap")}
        </div>
      </div>
      <ul className="confrontation-comparison__rows">
        {rows.map((row, index) => {
          const label = formatConfrontationParentCategoryLabel(
            row.parentCategory,
            t,
          );
          const gapLabel = formatSignedPercentValue(row.signedError, locale);

          return (
            <li
              className="confrontation-comparison__row"
              key={`${row.parentCategory}-${index}`}
            >
              <div className="confrontation-comparison__label">{label}</div>
              <div className="confrontation-comparison__bars">
                <div className="confrontation-comparison__bar-row">
                  <div className="confrontation-comparison__track">
                    <div
                      className="confrontation-comparison__bar confrontation-comparison__bar--manual"
                      style={{
                        width: `${clampPercent(row.manualMassPercent)}%`,
                      }}
                    />
                  </div>
                  <span className="confrontation-comparison__bar-value">
                    {formatPercentValue(row.manualMassPercent, locale, 1) ||
                      "—"}
                  </span>
                </div>
                <div className="confrontation-comparison__bar-row">
                  <div className="confrontation-comparison__track">
                    <div
                      className="confrontation-comparison__bar confrontation-comparison__bar--ai"
                      style={{ width: `${clampPercent(row.aiMassPercent)}%` }}
                    />
                  </div>
                  <span className="confrontation-comparison__bar-value">
                    {formatPercentValue(row.aiMassPercent, locale, 1) || "—"}
                  </span>
                </div>
              </div>
              <div className="confrontation-comparison__gap">
                {gapLabel || "—"}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ConfrontationComparisonChart;
